import { useMemo } from 'react'
import { Stack, Typography } from '@mui/material'
import { diffLines } from 'diff'

const DiffStats = ({ left, right }: { left: string; right: string }) => {
  const { added, removed } = useMemo(() => {
    let added = 0
    let removed = 0
    for (const part of diffLines(left, right)) {
      if (part.added) added += part.count ?? 0
      else if (part.removed) removed += part.count ?? 0
    }
    return { added, removed }
  }, [left, right])

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
      <Typography variant="caption" sx={{ fontFamily: 'monospace', color: 'success.main', fontWeight: 600 }}>
        +{added}
      </Typography>
      <Typography variant="caption" sx={{ fontFamily: 'monospace', color: 'error.main', fontWeight: 600 }}>
        −{removed}
      </Typography>
    </Stack>
  )
}

export default DiffStats
